<template>
  <div class="the-main-menu">
    <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
      <el-radio-button :label="false">expand</el-radio-button>
      <el-radio-button :label="true">collapse</el-radio-button>
    </el-radio-group> -->

    <el-menu :collapse="false">
      <el-submenu index="1">
        <template slot="title"><i class="el-icon-data-analysis"></i>Статистика</template>
        <el-menu-item-group>
          <router-link to="/stats-main" class="app__nav-item"><el-menu-item index="1-1">Общая статистика</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title"><i class="el-icon-user"></i>Пользователи</template>
        <el-menu-item-group>
          <router-link to="/users" class="app__nav-item"><el-menu-item index="2-1">Все пользователи</el-menu-item></router-link>
          <!-- <router-link to="/add-point" class="app__nav-item"><el-menu-item index="1-2">Добавить точку на карту</el-menu-item></router-link> -->
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3">
        <template slot="title"><i class="el-icon-s-grid"></i>Слайди</template>
        <el-menu-item-group>
          <router-link to="/slides" class="app__nav-item"><el-menu-item index="3-1">Усі слайди</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="4">
        <template slot="title"><i class="el-icon-location-outline"></i>Акции</template>
        <el-menu-item-group>
          <router-link to="/promos" class="app__nav-item"><el-menu-item index="4-1">Все Акции</el-menu-item></router-link>
          <router-link to="/points" class="app__nav-item"><el-menu-item index="4-2">Все Места</el-menu-item></router-link>
           <router-link to="/settings-points-categories" class="app__nav-item"><el-menu-item index="4-3">Категорії акцій</el-menu-item></router-link>
          <!-- <router-link to="/add-point" class="app__nav-item"><el-menu-item index="1-2">Добавить точку на карту</el-menu-item></router-link> -->
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="5">
        <template slot="title"><i class="el-icon-sugar"></i>Фонды</template>
        <el-menu-item-group>
          <router-link to="/foundations" class="app__nav-item"><el-menu-item index="5-1">Усі фонди</el-menu-item></router-link>
          <router-link to="/settings-foundations-categories" class="app__nav-item"><el-menu-item index="5-2">Категорії фондів</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="6">
        <template slot="title"><i class="el-icon-medal"></i>Старти</template>
        <el-menu-item-group>
          <router-link to="/starts" class="app__nav-item"><el-menu-item index="6-1">Усі старти</el-menu-item></router-link>
          <router-link to="/settings-starts-categories" class="app__nav-item"><el-menu-item index="6-2">Категорії стартів</el-menu-item></router-link>
          <router-link to="/settings-starts-organizers" class="app__nav-item"><el-menu-item index="6-3">Организатори стартів</el-menu-item></router-link>
          <router-link to="/settings-starts-price" class="app__nav-item"><el-menu-item index="6-4">Ціна</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="7">
        <template slot="title"><i class="el-icon-bank-card"></i>Транзакції</template>
        <el-menu-item-group>
          <router-link to="/transactions" class="app__nav-item"><el-menu-item index="7-1">Список транзакцій</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="8">
        <template slot="title"><i class="el-icon-discount"></i>Промокоди</template>
        <el-menu-item-group>
          <router-link to="/promocodes" class="app__nav-item"><el-menu-item index="8-1">Список промокодів</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="9">
        <template slot="title"><i class="el-icon-setting"></i>Утиліти</template>
        <el-menu-item-group>
          <router-link to="/utils-emails" class="app__nav-item"><el-menu-item index="9-1">Список розсилки</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="10">
        <template slot="title"><i class="el-icon-money"></i>Комісії</template>
        <el-menu-item-group>
          <router-link to="/settings-tax" class="app__nav-item"><el-menu-item index="10-1">Комісія kindchallenge</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="11">
        <template slot="title"><i class="el-icon-news"></i>Новини</template>
        <el-menu-item-group>
          <router-link to="/news" class="app__nav-item"><el-menu-item index="11-1">Усі новини</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="12">
        <template slot="title"><i class="el-icon-s-operation"></i>Настройки</template>
        <el-menu-item-group>
          <router-link to="/settings-languages" class="app__nav-item"><el-menu-item index="12-1">Языки</el-menu-item></router-link>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
/**
 * Component: the-main-menu - Главное меню отображаемое в боковой панели
*
* @version 1.0.0
*/


export default {
  name: 'the-main-menu',

  data() {
    return {
      isCollapse: false,
    };
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-main-menu {
  $this: &;

  height: calc(100% - 40px);
  padding-top: 20px;
  padding-bottom: 20px;
  border-right: 1px solid rgb(230, 230, 230);
}
</style>
